import { render } from "./Hospitals.vue?vue&type=template&id=1fa89e86&scoped=true"
import script from "./Hospitals.vue?vue&type=script&lang=js"
export * from "./Hospitals.vue?vue&type=script&lang=js"

import "./Hospitals.vue?vue&type=style&index=0&id=1fa89e86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa89e86"]])

export default __exports__